// HTTP for the data-centrifuge coordinator. Mirrors app/stats/page/comments/apiCalls.js:
// the project fetch helpers + AbortController signals, never $.ajax/jQuery. Covers the
// /dqr report fetch, the analyze-job POST, and cs restore/reject.

import { getCSRFParam, getCSRFToken } from '@aytm/lib/common/rails-post-fetch'
import { sendRawJSONData, sendJobJSONData } from '@aytm/app/stats/lib/fetch'

const addCSRF = data => {
  data[getCSRFParam()] = getCSRFToken()
  return data
}

// POST <statServerUrl>/dqr?key=… — the synchronous tier-gated aggregate replacing the /raw poll.
export const fetchDataQualityReport = ({ url, apiKey, signal }) =>
  sendJobJSONData({ url: `${url}?key=${apiKey ?? 0}`, method: 'POST', data: {}, signal })

// POST the analyze/run job to the stat job API (same shape as comments runSentiments).
export const fetchDataCentrifugeJob = ({ data, signal }) =>
  sendJobJSONData({ url: window.statJobApiUrl, method: 'POST', data: addCSRF(data), signal })

// POST cs restore — array form hits the bulk endpoint, scalar form the per-uid endpoint.
export const restoreResponses = ({ surveyId, uids, signal }) => {
  const isArray = Array.isArray(uids)
  const url = isArray
    ? `${window.aytm_domain}/surveys/${surveyId}/cs/restore`
    : `${window.aytm_domain}/surveys/${surveyId}/cs/${uids}/restore`
  return sendRawJSONData({ url, method: 'POST', data: addCSRF(isArray ? { ids: uids } : {}), signal })
}

// POST cs reject_dc for a single uid with a reason.
export const rejectResponse = ({ surveyId, uid, message, signal }) =>
  sendRawJSONData({
    url: `${window.aytm_domain}/surveys/${surveyId}/cs/${uid}/reject_dc`,
    method: 'POST',
    data: addCSRF({ message }),
    signal
  })
